import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deTranslation from './langs/de.json';
import enTranslation from './langs/en.json';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translation: enTranslation },
      // German carries only the seller-portal subtree; every other key
      // falls back to English via fallbackLng.
      de: { translation: deTranslation },
    },
    fallbackLng: 'en',
    detection: {
      // No persistence: the detector's default caches (localStorage +
      // cookie) would let the seller portal's changeLanguage() write a
      // language that the INTERNAL app on the same origin then reads on
      // its next load. Detection is cheap and the browser language is
      // stable, so re-detect per load and keep the trees independent.
      caches: [],
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
